function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "ic_Home",
  transform: "translate(-34.344 -32.376)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path",
  d: "M4,15H15V4H4V15ZM20.5,48h11V37h-11V48ZM4,48H15V37H4V48ZM4,31.5H15v-11H4v11Zm16.5,0h11v-11h-11v11ZM37,4V15H48V4ZM20.5,15h11V4h-11V15ZM37,31.5H48v-11H37v11ZM37,48H48V37H37V48Z",
  transform: "translate(30.344 28.376)",
  fill: "#191919",
  fillRule: "evenodd"
}));

var SvgIcHome = function SvgIcHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_Home.685ef489.svg";
export { ForwardRef as ReactComponent };